import { get } from "lodash-es";
import {
	MESApiService,
	type spParameter,
} from "../../../../services/ApiService";
import { Action } from "../models/Action";
import { Profile } from "../models/Profile";

//fx obtener profiles
export const getProfiles = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[SEC].[GetProfiles]", [], signal);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Profile[];
	} else {
		throw new Error(resp.message || "Error fetching users");
	}
};

export const upsertProfile = async ({
	ProfileId,
	ProfileName,
}: {
	ProfileId: number;
	ProfileName: string;
}) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ProfileId", value: ProfileId },
		{ name: "ProfileName", value: ProfileName },
	];

	const resp = await apiService.callV2("[SEC].[UpsertProfile]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error when upsert profile");
	}
};

// PROFILES PROCEDURES
export const getActions = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	const resp = await apiService.callV2(
		"[SEC].[GetActions]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Action[];
	} else {
		throw new Error(resp.message || "Error fetching actions");
	}
};

export const getActionsByProfileId = async (
	params: { profileId: number },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ProfileId", value: params.profileId },
	];

	const resp = await apiService.callV2(
		"[SEC].[GetActionsByProfileId]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Action[];
	} else {
		throw new Error(resp.message || "Error fetching actions of profile");
	}
};

//fx setear profiles de un profile
export const upsertProfileActions = async ({
	profileId,
	actions,
}: {
	profileId: number;
	actions: Action[];
}) => {
	const apiService = new MESApiService();

	const actionsIds = actions.map((item) => item.ActionId);
	const actionIdsString = actionsIds.join(",");

	const parameters: spParameter[] = [
		{ name: "ProfileId", value: profileId },
		{ name: "ActionIds", value: actionIdsString },
	];

	const resp = await apiService.callV2(
		"[SEC].[UpsertProfileActions]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error when upsert actions of profile");
	}
};

// fx eliminar profile
export const deleteProfile = async (profileId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "ProfileId", value: profileId }];

	const resp = await apiService.callV2("[SEC].[DeleteProfile]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error when delete profile");
	}
};

// fx clonar profile
export const cloneProfile = async ({
	SourceProfileId,
	NewProfileName,
}: {
	SourceProfileId: number;
	NewProfileName: string;
}) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "SourceProfileId", value: SourceProfileId },
		{ name: "NewProfileName", value: NewProfileName },
	];

	const resp = await apiService.callV2("[SEC].[CloneProfile]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error when cloning profile");
	}
};
